<template>
  <vs-row>
    <vs-col>
      <vs-row>
        <vs-col>
          <div class="vx-card__title mb-6"><h4 class="">{{ $t('dashboard.block.unclaimed_referrals.title') }}</h4></div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-table :data="referrals.$hasEmbedded('referrals') ? referrals.$getEmbedded('referrals') : []"
                    :noDataText="$t('dashboard.block.unclaimed_referrals.none')">
            <template slot="thead">
            <vs-th>
              {{ $t('dashboard.block.unclaimed_referrals.columns.sent') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.unclaimed_referrals.columns.since') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.unclaimed_referrals.columns.name') }}
            </vs-th>
            <vs-th>
              {{ userIdLabel || $t('dashboard.block.unclaimed_referrals.columns.id')}}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.unclaimed_referrals.columns.status') }}
            </vs-th>
            <vs-th>
            </vs-th>
            </template>

            <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].$getEmbedded('referral-acceptance').firstSent">
                {{ data[indextr].$getEmbedded('referral-acceptance').firstSent | moment('LL') }}
              </vs-td>

              <vs-td :data="data[indextr].$getEmbedded('referral-acceptance').firstSent">
                {{ data[indextr].$getEmbedded('referral-acceptance').firstSent | moment('from', 'now') }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].$getEmbedded('referral-claimant').firstname + ' ' + data[indextr].$getEmbedded('referral-claimant').lastname }}
              </vs-td>

              <vs-td :data="data[indextr].id">
                {{ data[indextr].$getEmbedded('referral-claim').claimNumber }}
              </vs-td>

              <vs-td :data="data[indextr].status">
                <span :class="data[indextr].status === 'ERRORED' ? 'text-danger':''">     {{ $t('filters.REFERRAL_STATUS.values.' + data[indextr].status) }}</span>
              </vs-td>

              <vs-td class="text-center" style="white-space: nowrap;">
                <sm-interval-button
                  v-if="data[indextr].$hasLink('notify-claimant')"
                  size="small"
                  type="filled"
                  color="primary"
                  class="mr-3"
                  :key="data[indextr].$getEmbedded('referral-acceptance').lastSent + indextr"
                  :label="$t('dashboard.block.unclaimed_referrals.buttons.resend')"
                  :baseTime="data[indextr].$getEmbedded('referral-acceptance').lastSent"
                  @click="onResend(data[indextr])">
                </sm-interval-button>


                <vs-button v-if="data[indextr].status === 'ERRORED' && data[indextr].$hasLink('edit')" @click="onEdit(data[indextr])" class="mt-2 mr-3" size="small" type="border" color="primary">
                  &nbsp;&nbsp;&nbsp;{{$t('dashboard.block.unclaimed_referrals.buttons.edit')}}&nbsp;&nbsp;&nbsp;
                </vs-button>

                <vs-button v-if="data[indextr].$hasLink('referral')" @click="onView(data[indextr])" class="mt-2 mr-3" size="small" type="filled" color="secondary">
                  {{$t('dashboard.block.unclaimed_referrals.buttons.view')}}
                </vs-button>
              </vs-td>
            </vs-tr>
            </template>
          </vs-table>
        </vs-col>
        <vs-col class="mt-5">
          <vs-row>
            <vs-col vs-w="6" vs-align="left" vs-justify="left" class="text-left">
              <a v-if="displaySeeMore" style="cursor:pointer;" @click="onSeeMore">
                [+] {{ $t('dashboard.block.unclaimed_referrals.buttons.view_more') }}
              </a>
              <a v-if="displaySeeLess" style="cursor:pointer;" @click="onSeeLess">
                [-] {{ $t('dashboard.block.unclaimed_referrals.buttons.view_less') }}
              </a>
            </vs-col>
            <vs-col vs-w="6" vs-align="right" vs-justify="right" class="text-right">
              <router-link :to="{name:'app-view-referrals'}">{{ $t('dashboard.block.unclaimed_referrals.buttons.view_all') }}</router-link>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import SmIntervalButton from '@/components/starling/sm-interval-button/sm-interval-button';

export default {
  name: 'dashboard-referral-list',
  components: {
    SmIntervalButton
  },
  props: {
    referralsResource: ResourceImpl
  },
  data () {
    return {
      referrals: this.referralsResource,
      userIdLabel: null
    };
  },
  mounted () {
    this.referralsResource.$request().$get('user-id-label', null, {locale:'en'}).then((res) => {
      this.userIdLabel = res.state().label;
    });
  },
  computed: {
    displaySeeMore () {
      return this.referrals && this.referrals.$hasEmbedded('referrals') && this.referrals.$hasLink('next') && this.referrals.page.size < 20;
    },
    displaySeeLess () {
      return this.referrals && this.referrals.$hasEmbedded('referrals') && this.referrals.page.totalElements > 5 && (this.referrals.page.size >= 20 || !this.referrals.$hasLink('next'));
    }
  },
  methods: {
    onSeeMore () {
      this.referrals.$request().$get('search', {size: this.referrals.page.size + 5}).then(res => {
        this.referrals = res;
      });
    },
    onSeeLess () {
      this.referrals.$request().$get('search', {size: 5}).then(res => {
        this.referrals = res;
      });
    },
    onResend (referral) {
      const claimant = referral.$getEmbedded('referral-claimant');
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: this.$t('dashboard.block.unclaimed_referrals.confirmations.resend.title'),
        text: this.$t('dashboard.block.unclaimed_referrals.confirmations.resend.text', {
          firstname: claimant.firstname,
          lastname: claimant.lastname
        }),
        accept: () => {
          referral.$request().$post('notify-claimant').then(() => {
            this.$emit('updated');

            this.$vs.notify({
              title: this.$t('dashboard.block.unclaimed_referrals.notifications.sent.title'),
              text: this.$t('dashboard.block.unclaimed_referrals.notifications.sent.text', {
                firstname: claimant.firstname,
                lastname: claimant.lastname
              }),
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
          }, () => {
            this.$vs.notify({
              title: this.$t('dashboard.block.unclaimed_referrals.notifications.not_sent.title'),
              text: this.$t('dashboard.block.unclaimed_referrals.notifications.not_sent.text', {
                firstname: claimant.firstname,
                lastname: claimant.lastname
              }),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        }
      });
    },
    onView (referral) {
      this.$router.push({
        name: 'app-view-referral',
        params: {id: referral.id}
      });
    },
    onEdit (referral) {
      this.$router.push({
        name: 'app-edit-referral',
        params: {
          id: referral.id
        }
      });
    }
  }
};
</script>
